var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-picker"},[_c('color-picker',{staticClass:"window",attrs:{"disableAlpha":true,"presetColors":_vm.presetColors},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }